import { alpha, styled } from '@mui/material';

type Mode = 'editor' | 'executions';

export const ToggleContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<{ disabled?: boolean }>(({ theme, disabled }) => ({
  position: 'relative',
  display: 'inline-grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  alignItems: 'stretch',
  padding: 3,
  borderRadius: 10,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,
  cursor: disabled ? 'not-allowed' : 'pointer',
  userSelect: 'none',
  opacity: disabled ? 0.55 : 1,
  transition: theme.transitions.create(['opacity', 'border-color']),
  ...(!disabled && {
    '&:hover': { borderColor: alpha(theme.palette.primary.main, 0.5) },
  }),
}));

export const TogglePill = styled('div', {
  shouldForwardProp: (prop) => prop !== 'mode',
})<{ mode: Mode }>(({ theme, mode }) => ({
  position: 'absolute',
  top: 3,
  bottom: 3,
  left: 3,
  width: 'calc(50% - 3px)',
  borderRadius: 7,
  backgroundColor: theme.palette.primary.light,
  boxShadow: `0 2px 10px ${alpha(theme.palette.primary.light, 0.45)}`,
  transform: mode === 'executions' ? 'translateX(100%)' : 'translateX(0)',
  transition: theme.transitions.create('transform', {
    duration: 220,
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
  }),
}));

export const ToggleSegment = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.5, 1.5),
  fontFamily: theme.typography.button.fontFamily,
  fontSize: '0.875rem',
  fontWeight: 700,
  whiteSpace: 'nowrap',
  color: active ? theme.palette.getContrastText(theme.palette.primary.light) : theme.palette.text.secondary,
  transition: theme.transitions.create('color'),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5, 1.25),
  },
}));

export const SegmentLabel = styled('span')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const SegmentIcon = styled('span')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': { fontSize: 18 },
  },
}));
